module.exports = __webpack_public_path__ + "static/media/line.e1ca8f60.svg";